module.exports = __webpack_public_path__ + "img/bg02.83bff184.gif";